<template>
  <div class="evenement-list">
    <Toolbar :handle-add="addHandler" />

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1>Dates de Ludinam</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <EvenementFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            :items-per-page.sync="options.itemsPerPage"
            :loading="isLoading"
            :loading-text="$t('Loading...')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            show-select
            @update:options="onUpdateOptions"
            :footer-props="{
              'items-per-page-options': [15, 30, 50, 100],
            }"
          >
                <template slot="item.dateDebut" slot-scope="{ item }">
                  {{ formatDateTime(item['dateDebut'], 'long') }}
                </template>
                <template slot="item.dateFin" slot-scope="{ item }">
                  {{ formatDateTime(item['dateFin'], 'long') }}
                </template>
                <template slot="item.sites" slot-scope="{ item }">
                  <ul>
                    <li v-for="_item in item['sites']" :key="_item.id">
                      {{ _item.id }}
                    </li>
                  </ul>
                </template>
                <template slot="item.animations" slot-scope="{ item }">
                  <div v-for="(_item, index) in item['animations']" :key="_item.id">
                    <div  v-if="index == items.length - 1">
                      {{ index }}
                    </div>
                  </div>
                </template>

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
              :handle-edit="() => editHandler(props.item)"
              :handle-delete="() => deleteHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import EvenementFilterForm from '../../components/evenement/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';

export default {
  name: 'EvenementList',
  servicePrefix: 'Evenement',
  mixins: [ListMixin],
  components: {
    Toolbar,
    ActionCell,
    EvenementFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: 'Nom', value: 'nom' },
        { text: 'Date de début', value: 'dateDebut' },
        { text: 'Date de fin', value: 'dateFin' },
        { text: 'Sites', value: 'sites' },
        { text: 'Animations', value: 'animations' },
        {
          text: 'Actions',
          value: 'action',
          sortable: false
        }
      ],
      selected: []
    };
  },
  computed: {
    ...mapGetters('evenement', {
      items: 'list'  
    }),
    ...mapFields('evenement', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
  
  },
  methods: {
    ...mapActions('evenement', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
    
  }
};
</script>
